import { z } from 'zod';
import { Url } from '../../types';
import { saveLogsPayloadSchema } from './logs.schema';

export type SaveLogsPayload = {
  duration: number;
  type: string;
  subtype: string;
  annotation?: Url;
  queue?: Url;
};

export const saveLogs = (payload: SaveLogsPayload) => {
  return {
    endpoint: '/internal/logs',
    method: 'POST',
    responseSchema: z.unknown(),
    payloadSchema: saveLogsPayloadSchema,
    payload,
  } as const;
};
